"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingRequestKey = void 0;
var PendingRequestKey;
(function (PendingRequestKey) {
    PendingRequestKey["REFRESH_TOKEN"] = "refreshTokenRequest";
    PendingRequestKey["GET_ACCESS_TOKEN"] = "getAccessTokenRequest";
})(PendingRequestKey = exports.PendingRequestKey || (exports.PendingRequestKey = {}));
